import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problema } from './components/Problema';
import { Solucion } from './components/Solucion';
import { Incluye } from './components/Incluye';
import { Beneficios } from './components/Beneficios';
import { Comparacion } from './components/Comparacion';
import { Precio } from './components/Precio';
import { ParaQuien } from './components/ParaQuien';
import { Testimonios } from './components/Testimonios';
import { FAQ } from './components/FAQ';
import { Cierre } from './components/Cierre';
import { Footer } from './components/Footer';
import { ActivityPopup } from './components/ActivityPopup';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen flex flex-col font-body bg-mc-dark text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problema data-id="element-4" />
        <Solucion data-id="element-5" />
        <Incluye data-id="element-6" />
        <Beneficios data-id="element-7" />
        <Comparacion data-id="element-8" />
        <Precio data-id="element-9" />
        <ParaQuien data-id="element-10" />
        <Testimonios data-id="element-11" />
        <FAQ data-id="element-12" />
        <Cierre data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <ActivityPopup data-id="element-15" />
    </div>;
}